module.exports = __webpack_public_path__ + "static/media/upload-photo.f373a634.svg";